import React, { useEffect, useState } from 'react'
import {
  Form,
  FileWrapper,
  File,
  Button,
  Field,
  FieldLabel,
  Input
} from './styles'
import { Icon } from '../../../assets/icons'
import { AiFillCamera } from 'react-icons/ai'
import { useGallery, useGameWrapper, useGame } from '../../../contexts'
import { getTeam } from '../../../utils/team_helpers'
import { makePostMissionAnswer } from '../../../../main/usecases/mission-answer/post-mission-answer-factory'
import { addAllowFullScreen, replaceInstructionsTags } from '../../../utils/mission_helpers'
import { Container, Image, Instructions, ActionButtons, DragDropButton, GroupButtons } from '../styles'
import { getAssetUrl } from '../../../utils/assets_helpers'
import { YoutubeCarousel } from '../../youtube_carousel'
import { t } from '../../../adapters/translate/translate'
import { isMobile } from '../../../utils/general'
import { IoIosAttach } from 'react-icons/io'
import { replaceHtmlEntity } from '../../../utils/text_replace'

const PhotoTimeMission = () => {
  const [instructions, setInstructions] = useState<string|null>('')
  const [description, setDescription] = useState('')
  const { loadImages, setOpenCamera, setIsFilePicked, isFilePicked, setFileURL, fileURL, setFile, file } = useGallery()
  const [color, setColor] = useState<any>('#fff')
  const team = getTeam()
  const { timeout, currentMission, submitCallback, doSubmit, submitButtonIsEnabled, handleToggleStatusSubmitButton, setTimePaused } = useGameWrapper()
  const { game } = useGame()
  const [dragColor, setDragColor] = useState('#f0f0f0')
  const mobile = isMobile()

  const resetMission = () => {
    setIsFilePicked(false)
    setFileURL('')
    setFile(null)
    setIsFilePicked(false)
  }

  const handleFileToggle = () => {
    return 'file changed'
  }

  async function sendAnswer () {
    try {
      if (team.id) {
        const formData = new FormData()
        formData.append('mission', currentMission?.uuid || '')
        formData.append('imageFile', file)
        formData.append('team', team.id)
        formData.append('subtitle', description)

        if (timeout) {
          formData.append('status', 'timeout')
        } else {
          formData.append('status', 'responded')
        }

        const res = await makePostMissionAnswer('/image_upload').post(formData)
        loadImages()
        return res
      }
    } catch (error) {
      console.error('MultipleChoiceMission.sendAnswer', error)
    }
  }

  function handleEnableButton () {
    if (!file) {
      handleToggleStatusSubmitButton(false)
    } else {
      handleToggleStatusSubmitButton(true)
    }
  }

  function handlePaste (e: any) {
    if (e.type === 'drop') {
      e.preventDefault()
    }

    const transfer = e.clipboardData || e.dataTransfer

    if (!transfer.items.length) {
      setDragColor('#f0f0f0')
      return
    }

    const fileObject = transfer.items[0]

    if (fileObject.type?.search('image') === -1) {
      setDragColor('#f0f0f0')
      return
    }

    const URLObj = window.URL || window.webkitURL
    const blob = fileObject.getAsFile()
    const url = URLObj.createObjectURL(blob)

    setFile(transfer.files[0])
    setFileURL(url)
    setIsFilePicked(true)
    setDragColor('#f0f0f0')
  }

  function handleDrag (event: any) {
    event.preventDefault()
    setDragColor(event.type === 'dragleave' ? '#f0f0f0' : '#d9d9d9')
  }

  useEffect(() => {
    if (!currentMission) return
    const formattedInstructions = replaceInstructionsTags({ mission: currentMission, points: currentMission.pointsIfCorrect })
    setInstructions(addAllowFullScreen(formattedInstructions))
  }, [currentMission])

  useEffect(() => {
    handleFileToggle()
    handleEnableButton()
  }, [file, isFilePicked])

  useEffect(() => {
    if (doSubmit && submitButtonIsEnabled) {
      submitCallback(sendAnswer)
    }
  }, [doSubmit, submitButtonIsEnabled])

  useEffect(() => {
    if (timeout) {
      submitCallback(sendAnswer)
    }
  }, [timeout])

  useEffect(() => {
    resetMission()
  }, [currentMission])

  useEffect(() => {
    setTimePaused(false)
    if (game) { setColor(game?.textColor || '#fff') }
  }, [game])

  useEffect(() => {
    const div = document.getElementById('instructions')
    if (div) {
      div.innerHTML = replaceHtmlEntity(div.innerHTML)
    }
  }, [instructions])

  return (
    <Container>
      { currentMission?.icon && <Image src={getAssetUrl('icon', String(currentMission?.icon))} /> }
      {!!instructions && <Instructions id="instructions" dangerouslySetInnerHTML={
        { __html: instructions }
      } />}

      {currentMission?.options.video && <YoutubeCarousel videos={['https://www.youtube.com/embed/E7wJTI-1dvQ']}/>}
      {mobile && <ActionButtons>
        <button onClick={() => setOpenCamera(true)} style={{ borderColor: game?.baseColor }}>
          <AiFillCamera fill={game?.baseColor}/>
          <h3 style={{ color: game?.baseColor }}>{t('Take photo')}</h3>
        </button>
      </ActionButtons>}
      {!mobile && (
        <GroupButtons>
          <DragDropButton onPaste={handlePaste} onDrop={handlePaste} onDragOver={handleDrag} onDragEnter={handleDrag} onDragLeave={handleDrag} style={{ borderColor: game?.baseColor, color: game?.baseColor, backgroundColor: dragColor }}>
            <IoIosAttach fill={game?.baseColor}/>
            <h3>
              {t('Drag or paste your photo here')}
            </h3>
          </DragDropButton>
          <h4>{t('or')}</h4>
          <button onClick={() => setOpenCamera(true)} style={{ borderColor: game?.baseColor }}>
            <AiFillCamera fill={game?.baseColor}/>
            <h3 style={{ color: game?.baseColor }}>{t('Take photo')}</h3>
          </button>
        </GroupButtons>
      )}
      <Form $isOpen={ isFilePicked }>
        <FileWrapper>
          <File src={String(fileURL)}/>
          <Button onClick={resetMission}>
            <Icon name="x"/>
          </Button>
        </FileWrapper>

        <Field>
          <FieldLabel style={{ color }}>{t('Photo caption')}</FieldLabel>
          <Input
            value={description}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
            placeholder={`${t('Enter here')}...`}
          />
        </Field>
      </Form>
    </Container>
  )
}

export default PhotoTimeMission
